<template>
  <v-card max-width="1000" width="100%">
    <v-card-text class="pa-0" style="height: 100%">
      <v-row class="ma-0" style="height: 100%">
        <v-col md="6" class="pa-0 login-content">
          <div class="logo">
            <img
              width="50"
              src="@/assets/images/logo_auth_yellow_512px.png"
              alt="logo_auth_yellow_512px"
            />
            <h1>Auth</h1>
          </div>
        </v-col>
        <v-col md="6">
          <form-login @snackbar="$emit('snackbar', $event)" class="login-form" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Form from "./components/Form.vue";

@Component({
  components: {
    "form-login": Form,
  },
})
export default class Login extends Vue {}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/utils/_mixins.scss", "@/assets/styles/utils/_variables.scss";

.logo {
  display: flex;
  background: #1e1e1e;
  color: #ffeb3b;
  width: 100%;
  height: 100%;
  border-radius: 2px 0 0 2px;
  justify-content: center;
  align-items: center;

  h1 {
    color: #ffeb3b;
    font-weight: normal;
    margin-left: 8px;
  }
}

body {
  overflow: hidden;
}

.login {
  max-width: 500px;
  @media (max-width: 800px) {
    &-content {
      display: none !important;
    }
  }
}
</style>
